module.exports = __webpack_public_path__ + "img/Vinted.9c51f7a7.jpg";